<div class="audit-content" fxLayout fxFlex>
  <div class="audit-rb" fxFlex="85">
    <ul class="nav nav-tabs">
      <li [ngClass]="{ active: displayScoring }">
        <a [routerLink]="" (click)="onSwitch(true)">Audit Scoring</a>
      </li>
      <li [ngClass]="{ active: !displayScoring }">
        <a [routerLink]="" (click)="onSwitch(false)">Severity Ranking</a>
      </li>
    </ul>
    @if (displayScoring) { @if (selectedTemplateKey !== '0' && selectedUserId
    === currentUserId) {

    <div class="oneLine">
      <mat-form-field class="score-name">
        <mat-label>Score Name:</mat-label>
        <input matInput type="text" [(ngModel)]="newScoreName" />
      </mat-form-field>
      <mat-form-field class="score-value">
        <mat-label>Score Value:</mat-label>
        <input
          matInput
          type="number"
          value="0"
          [formControl]="scoreValueControl"
        />
        @if (scoreValueControl.hasError('min')) {
        <mat-error>Score must be greater or equal to zero.</mat-error>
        } @if (scoreValueControl.hasError('required')) {
        <mat-error>Score value is required.</mat-error>
        }
      </mat-form-field>
      <button
        [disabled]="
          newScoreName == undefined ||
          scoreValueControl.hasError('min') ||
          scoreValueControl.hasError('required')
        "
        class="score-add"
        matSuffix
        mat-button
        aria-label="Clear"
        (click)="onAddScoring(newScoreName, scoreValueControl.value)"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    }
    <div class="normal-content">
      @for (ac of scoringList; track ac) {
      <div class="table-content" fxLayout fxFlex>
        <span fxFlex="25">{{ ac.ScoringName }}</span>
        <div fxFlex="75">
          <span>Score:</span
          ><input class="score-value" [value]="ac.ScoringValue" disabled />
          @if (selectedTemplateKey != 0) {
          <input
            class="rankingcolor"
            [colorPicker]="ac.HexColor"
            [style.background]="ac.HexColor"
            [cpOKButton]="true"
            [disabled]="selectedUserId != currentUserId"
            [cpSaveClickOutside]="false"
            [cpOKButtonClass]="'btn btn-primary btn-xs'"
            (colorPickerSelect)="onColorChange($event, ac.ScoringKey)"
          />
          } @if (selectedTemplateKey == 0) {
          <input
            class="rankingcolor"
            [style.background]="ac.HexColor"
            (click)="onDefaultRank()"
          />
          } @if (this.selectedTemplateKey != 0) {
          <button
            matTooltip="edit"
            matTooltipClass="tooltip1"
            class="button-action"
            mat-button
            [disabled]="selectedUserId != currentUserId"
            (click)="onEditScoring(ac.ScoringKey)"
          >
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
          </button>
          } @if (this.selectedTemplateKey != 0) {
          <button
            matTooltip="delete"
            [disabled]="selectedUserId != currentUserId"
            matTooltipClass="tooltip1"
            class="button-action"
            mat-button
            (click)="onDeleteScoring(ac.ScoringKey)"
          >
            <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
          </button>
          }
        </div>
      </div>
      }
    </div>
    }@if (!displayScoring) {
    <div class="alert alert-info">
      <strong>Please note:</strong>
      You are unable to add more than 10 items of severity at this time. Please
      delete some before adding new items.
      <br />
    </div>
    @if ((!rankingList || (rankingList && rankingList.length < 10)) &&
    selectedUserId == currentUserId) {
    <div class="oneLine">
      <mat-form-field class="one-row">
        <input
          matInput
          type="text"
          [(ngModel)]="newRank"
          placeholder="Add custom ranking element"
        />
      </mat-form-field>
      <button
        mat-button
        [disabled]="newRank == undefined"
        class="score-add"
        matSuffix
        aria-label="Clear"
        (click)="onAddRank(newRank)"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    } @if (rankingList != undefined) { @for (ac of rankingList; track ac) {
    <ul class="table-content" fxLayout fxFlex>
      <li fxFlex="40">
        {{ ac.RankingName }}
      </li>
      <li fxFlex="60">
        <div>
          @if (ac.RankingKey != 0) {
          <input
            class="rankingcolor"
            [colorPicker]="ac.HexColor"
            [style.background]="ac.HexColor"
            [cpOKButton]="true"
            [cpSaveClickOutside]="false"
            [disabled]="selectedUserId != currentUserId"
            [cpOKButtonClass]="'btn btn-primary btn-xs'"
            (colorPickerSelect)="onColorChange($event, ac.RankingKey)"
          />
          } @if (ac.RankingKey == 0) {
          <input
            class="rankingcolor"
            [style.background]="ac.HexColor"
            (click)="onDefaultRank()"
          />
          } @if (ac.RankingKey != 0) {
          <button
            matTooltip="edit"
            [disabled]="selectedUserId != currentUserId"
            matTooltipClass="tooltip1"
            class="button-action"
            mat-button
            (click)="onEditRanking(ac.RankingKey)"
          >
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
          </button>
          } @if (ac.RankingKey != 0) {
          <button
            matTooltip="delete"
            [disabled]="selectedUserId != currentUserId"
            matTooltipClass="tooltip1"
            class="button-action"
            mat-button
            (click)="onDeleteRanking(ac.RankingKey)"
          >
            <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
          </button>
          }
        </div>
      </li>
    </ul>
    } } }
  </div>
</div>
